export default __webpack_public_path__ + "static/aymanejed-laptop-3196481_1920-4652052568fece26f55651e476e34c9f.jpg";